export default {
  getParcelaCoordenadaTpl: state => {
    let table = 'ParcelaCoordenada'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
